// history.tsx
import { createBrowserHistory } from "history";
// https://github.com/ReactTraining/react-router/issues/4895#issuecomment-305182551
const createdHistory = createBrowserHistory();
export default createdHistory;
